module.exports = __webpack_public_path__ + "static/media/bg.b4db4941.jpg";